import { BaseLayout } from "@components/general/base_layout";
import { Outlet } from "react-router-dom";

export const SchoolPage = () => {
  return (
    <BaseLayout>
      <Outlet />
    </BaseLayout>
  );
};
